export default __webpack_public_path__ + "static/media/btn.9bdedd77.svg";